const [w,d,l] = [window,document,location]

const process_init = () => {
  if( d.body.classList.contains('is--detail') || /article=[\d+]/.test(l.search) ){
    const catname = d.querySelector('.catetitle').textContent
    const subject = d.querySelector('.hs_entrytitle').textContent
    const catchcp = d.querySelector('.catchcp').textContent
    $(`
      <div class="p-process-detail__title">
        <h4 class="p-process-detail__title-subject">${subject}</h4>
        <span class="p-process-detail__title-category">${catname}</span>
        <p class="p-process-detail__title-catch">${catchcp}</p>
      </div>
    `).prependTo('.element_detail')
    $('.detail_title,>.title,.titleTxt','.element_detail').remove()
  }

}

export default function PROCESS () {
  w.addEventListener('DOMContentLoaded',process_init)
}